import {
  SisterSearcherCpSpeedConsumption,
  SisterSearcherPerformancePoint,
  SisterSearcherPerformancePointKey,
} from "../models/sister-searcher.models";

export const formatSisterSearcherValue = (value: unknown): string => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  if (typeof value === "boolean") {
    return value ? "Yes" : "No";
  }

  if (typeof value === "number") {
    return value.toLocaleString("en-US", { maximumFractionDigits: 2 });
  }

  return String(value);
};

export const formatCpSpeedConsumption = (value: SisterSearcherCpSpeedConsumption): string => {
  const facts = [
    ["Speed", value.speed],
    ["LSF", value.lsf],
    ["IFO", value.ifo],
    ["MGO", value.mgo],
    ["LSG", value.lsg],
    ["Total", value.totalConsumption],
  ].filter((fact): fact is [string, number] => fact[1] !== null);

  return facts.length > 0
    ? facts.map(([label, fact]) => `${label} ${formatSisterSearcherValue(fact)}`).join(" | ")
    : "—";
};

export const formatSisterSearcherPerformancePoint = (
  point: SisterSearcherPerformancePoint,
  key: SisterSearcherPerformancePointKey,
): string => {
  if (key === "cpSpeedConsumption") {
    return formatCpSpeedConsumption(point.cpSpeedConsumption);
  }

  return formatSisterSearcherValue(point[key]);
};

export const getSisterSearcherErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
